define((require) => {
    "use strict";

    const TransformableTextEnhancedWidget         = require("ui/experience/widgets/textEnhancedWidget/TransformableTextWidget");
    const TransformableTextWidget                 = require("ui/experience/widgets/textWidget/TransformableTextWidget");
    const TransformableSalesforceCommerceWidget   = require("ui/experience/widgets/salesforceCommerceWidget/view/TransformableSalesforceCommerceWidget");

    /**
     * The Idea of this class is avoid the mixin between (Editor and Viewer)Widget class.<p>
     * <ol>
     *  <li>#E.g. 1<p>
     *  The TextWidget that handlers a lot of different interactions in the editor, but inside of the view only display a simple text with styles.
     *
     *  <li>#E.g. 2<p>
     *  The SalesforceCommerceWidget that in the editor shows the SalesforceCommerceProduct (image,id,name), however in the widget
     *  only makes a call for the SalesforceCommerceClient Api.
     * </ol>
     * @class TextWidgetView
     * @constructor
     *
     */
    return {

        /**
         * Returns a <tt>TransformableWidget</tt> instance wrapped around the specified widget.
         *
         * @param  {String} type of the widget e.g. text, demandware
         * @param  {Object} widget instance
         *
         * @return {TransformableWidget}       A <tt>TransformableWidget</tt> instance wrapped around the specified widget.
         */
        create(type, widget) {
            switch (type) {
                case "text":
                    return TransformableTextWidget;

                case "text-enhanced":
                    return TransformableTextEnhancedWidget;

                /** @see {WidgetTypes.SALESFORCE_COMMERCE} */
                case "demandware":
                    return TransformableSalesforceCommerceWidget;

                default:
                    return widget;
            }
        }
    };
});



// WEBPACK FOOTER //
// ./src/editor/ui/experience/widgets/TransformableWidgetFactory.js